(() => {
  const script = document.currentScript;
  if (!script || !script.dataset.value || !script.dataset.updateUrl) return;

  let pending;

  function observeCart() {
    if (pending) return pending;
    // Creating an empty cart alongside a first add can race its Set-Cookie.
    // Wait for Shopify to establish the shopper's cart before updating it.
    if (!/(?:^|;\s*)cart=[^;]+/.test(document.cookie)) {
      script.dataset.status = 'no-cart';
      return Promise.resolve(false);
    }
    script.dataset.status = 'pending';
    const controller = new AbortController();
    pending = new Promise((resolve) => {
      let settled = false;
      const finish = (accepted) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        script.dataset.status = accepted ? 'accepted' : 'failed';
        pending = undefined;
        resolve(accepted);
      };
      const timeout = window.setTimeout(() => {
        // Settle even if an app's fetch wrapper ignores AbortSignal.
        finish(false);
        controller.abort();
      }, 4000);
      // Private attributes cannot be read back through Ajax. Do not cache success
      // in browser storage: checkout or recovery can replace the underlying cart.
      Promise.resolve().then(() => fetch(script.dataset.updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { __kq_storefront_seen__: script.dataset.value } }),
        signal: controller.signal,
      })).then((response) => finish(response.ok), () => finish(false));
    });
    return pending;
  }

  window.kqEnsureMarker = observeCart;

  // These events follow completed adds, including UPEZ's fetch/XHR paths.
  // Do not listen to general cart updates: our own attribute write causes those.
  document.addEventListener('cart:refresh', observeCart);
  document.addEventListener('UPEZ__CART_REFETCHED_AFTER_ADD', observeCart);

  const checkoutSelectors = ['#upezCart button[upnova-action="checkout"]', '#cart_checkout_btn'];
  let waitingForCheckout = false;
  let resumingCheckout = false;

  function beforeCheckout(event, control, resume) {
    if (resumingCheckout || event.defaultPrevented || !event.cancelable) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (waitingForCheckout) return;
    waitingForCheckout = true;
    const busy = control.getAttribute('aria-busy');
    control.setAttribute('aria-busy', 'true');

    const continueCheckout = () => {
      if (busy === null) control.removeAttribute('aria-busy');
      else control.setAttribute('aria-busy', busy);
      resumingCheckout = true;
      try {
        resume();
      } finally {
        resumingCheckout = false;
        waitingForCheckout = false;
      }
    };
    // The helper settles within four seconds. Even a synchronous error must
    // release checkout; the marker is observation, not permission to purchase.
    Promise.resolve().then(observeCart).then(continueCheckout, continueCheckout);
  }

  window.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const control = event.target.closest?.(checkoutSelectors.join(','));
    if (!control || control.disabled) return;
    const selector = checkoutSelectors.find((candidate) => control.matches(candidate));
    beforeCheckout(event, control, () => {
      // UPEZ may rerender its button while the marker request is pending.
      // Resume its actual handler so discounts/protection and app validation survive.
      const current = control.isConnected ? control : document.querySelector(selector);
      if (current && !current.disabled) current.click();
    });
  }, true);

  window.addEventListener('submit', (event) => {
    const control = event.submitter;
    if (event.target.id !== 'cart_form' || control?.id !== 'cart_checkout_btn') return;
    if (typeof event.target.requestSubmit !== 'function') return;
    beforeCheckout(event, control, () => {
      if (control.isConnected && !control.disabled) event.target.requestSubmit(control);
    });
  }, true);

  observeCart();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) observeCart();
  });
  if (window.PerformanceObserver) {
    try {
      const observer = new window.PerformanceObserver((list) => {
        if (list.getEntries().some((entry) => {
          const url = new URL(entry.name, window.location.href);
          return url.origin === window.location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname);
        })) observeCart();
      });
      observer.observe({ type: 'resource', buffered: true });
    } catch (_) {
      // Some browsers expose the API but cannot observe resource entries.
      // Completed-add events and the checkout check remain available.
    }
  }
})();
